import FormatQuoteRounded from '@mui/icons-material/FormatQuoteRounded';
import TagRounded from '@mui/icons-material/TagRounded';
import {
  Box,
  SvgIconProps,
  SvgIconTypeMap,
  Typography,
  TypographyProps,
} from '@mui/material';
import { ExtraProps } from 'react-markdown';

type LabelNameProps = React.ClassAttributes<HTMLElement> &
  React.HTMLAttributes<HTMLElement> &
  ExtraProps & {
    iconColor?: SvgIconProps['color'];
    textProps?: TypographyProps;
  };

export function LabelName({
  children,
  node,
  iconColor,
  textProps,
  onMouseEnter,
  onMouseLeave,
}: LabelNameProps) {
  const iconProps: SvgIconTypeMap['props'] = {
    fontSize: 'small',
  };

  const IconComponent =
    node?.tagName === 'tk' ? TagRounded : FormatQuoteRounded;

  return (
    <Box
      component="span"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <IconComponent {...iconProps} />
      <Typography
        component="span"
        variant="body1"
        fontStyle="italic"
        sx={{ ml: 0.5 }}
        {...textProps}
      >
        {children}
      </Typography>
    </Box>
  );
}
